import React from 'react'
import { useTranslation } from 'react-i18next'

import { InformationModal } from '../../../global/modal/InformationModal'
import { Text, TextH3 } from '../../../ui/Typography/Typography'

import styles from './BecomeIBModal.module.scss'

interface Props {
  onCancel: () => void
}

export const EarnRewardsModal: React.FC<Props> = ({ onCancel }) => {
  const { t } = useTranslation()

  return (
    <InformationModal
      title={t(`IB.Tickmill's Loyalty Program offers you more earning opportunities`)}
      onCancelText={t('Got It')}
      onCancel={onCancel}
    >
      <div className={styles.earnModal}>
        <div className={styles.item}>
          <TextH3>{t('IB.Up to US$ 250,000')}</TextH3>
          <Text isParagraph>{t('IB.Redeem cash rewards on top of your regular IB payouts')}</Text>
        </div>
        <div className={styles.item}>
          <TextH3>{t('IB.Volume Tiers', { tiers: 13 })}</TextH3>
          <Text isParagraph>
            {t('IB.Achieve the volume requirement on each tier to redeem the respective prizes', {
              from: '25',
              to: '250,000',
            })}
          </Text>
          <a
            className='is-link'
            target='_blank'
            href='https://www.tickmill.com/partners/ib-loyalty'
            rel='noreferrer'
          >
            {t('Loyalty Program.Find out more')}
          </a>
        </div>
      </div>
    </InformationModal>
  )
}
